<nav class="d-flex justify-content-around align-items-baseline align-items-md-center main w-100">
  <div class="ps-2 w-75">
    <a>
      <figure class="">
        <img class="img-fluid" src="assets/images/logoLazio.png" alt="">
      </figure>
    </a>
  </div>
  <div class="d-flex justify-content-end w-25">
    <div class="d-flex align-items-center justify-content-center px-3">
      <div class="fl d-none d-lg-block">
        <p class="fw-semibold text-dark">GUIDA</p>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center px-3">
      <div class="d-flex justify-content-end cursor-pointer" (click)="openModal()">
        <mat-icon>info</mat-icon>
      </div>
    </div>
  </div>
</nav>
